import {gettext} from '../../translations';
import {parseDate} from 'js-utils/datetime';

import {constants as destinationConstants} from '@eb/destination-utils';

import {
    GA_HOME_V2_LABEL_CUSTOM_DATE,
} from '../../constants/analytics';

const {
    DATE_TAG,
    CUSTOM_DATE,
} = destinationConstants;

/*********************** STATE SELECTORS ***********************/

//Utilizes the formatDate util found in dateTime but performs some extra logic
export const formatDateRangeStringForDisplay = ({startDate = '', endDate = ''}) => {
    const {day: startDay, month: startMonth} = parseDate(startDate);
    const {day: endDay, month: endMonth} = parseDate(endDate);

    //Translators: Feb 3 - Mar 5
    let formattedDateString = gettext(
        '%(startMonth)s %(startDay)s - %(endMonth)s %(endDay)s',
        {startDay, startMonth, endDay, endMonth}
    );

    if (startDate === endDate) {
        //Translators: Feb 3
        formattedDateString = gettext('%(startMonth)s %(startDay)s', {startDay, startMonth});
    }

    return formattedDateString;
};

/*********************** GA UTILS ***********************/

/*
 Receives dates data and returns it in the correct format for analytics tracking

 @param dates - object

 @return string
*/
export const formatDatesForGATracking = (dates) => {
    let searchedDate = '';

    if (dates) {
        searchedDate = GA_HOME_V2_LABEL_CUSTOM_DATE;
        const dateIsAFixedDateTag = typeof dates === 'string' && dates !== CUSTOM_DATE && dates !== DATE_TAG;

        if (dateIsAFixedDateTag) {
            searchedDate = dates;
        }
    }
    return searchedDate;
};

/*
    Receives dates and returns a correct format for GA tracking
    Fixed tags: 'today'
    Custom dates: '2019-04-09--2019-04-10'

    @param dates - object

    @return string
*/
